import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "display", "increment", "decrement"]
  static values = {
    min: { type: Number, default: 0 },
    max: Number,
    step: { type: Number, default: 1 }
  }

  connect() {
    this.#updateButtons();
  }

  increment() {
    const currentValue = parseInt(this.inputTarget.value);
    const newValue = currentValue + this.stepValue;

    if (!this.maxValue || newValue <= this.maxValue) {
      this.#updateValue(newValue);
    }
  }

  decrement() {
    const currentValue = parseInt(this.inputTarget.value);
    const newValue = Math.max(this.minValue, currentValue - this.stepValue);

    this.#updateValue(newValue);
  }

  #updateValue(value) {
    this.inputTarget.value = value;
    this.displayTarget.textContent = value;
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }));
    this.#updateButtons();
  }

  #updateButtons() {
    const currentValue = parseInt(this.inputTarget.value);

    // Disable decrement if at minimum
    this.decrementTarget.disabled = currentValue <= this.minValue;

    // Disable increment if at maximum
    this.incrementTarget.disabled = this.maxValue && currentValue >= this.maxValue;
  }
}
